export const pwError = (pw, confirm) => {
  if (pw.length < 6 || pw.length > 72) return "Password harus 6–72 karakter.";
  if (confirm !== undefined && pw !== confirm) return "Konfirmasi password tidak sama.";
  return "";
};
